"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WatchStuds = void 0;
const core_1 = require("@babylonjs/core");
class WatchStuds {
    constructor(importloadStudsResult) {
        this._mesh = importloadStudsResult.meshes[0];
        this._mesh.position.y = 1;
    }
    get Mesh() {
        return this._mesh;
    }
    static CreateAsync(scene, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const importStudsResult = yield core_1.SceneLoader.ImportMeshAsync("", params.assetUrlRoot, params.assetUrlWatchStuds, scene);
            const fireTexture = core_1.CubeTexture.CreateFromPrefilteredData(params.assetUrlRoot + params.assetUrlDiamondFireTexture, scene);
            scene.getMaterialByName("diamond_fire").reflectionTexture = fireTexture;
            return new WatchStuds(importStudsResult);
        });
    }
}
exports.WatchStuds = WatchStuds;
